module.exports = __webpack_public_path__ + "img/btn-bg-grey.e594b1fa.png";